import React from 'react';
import Modal from 'react-modal';

import modal from '../../../definitions/Modal';
import { FormattedMessage } from 'react-intl';
import Row from '../../tag/Row';
import Span from '../../tag/Span';
import OTButton from '../../tag/OTButton';
import Loader from '../../Loader';
import OTButtonGroup from '../../tag/OTButtonGroup';

const style = modal({ content: { width: '400px', textAlign: 'left' } });

let { id: module_id } = module;

const AppointmentModal = (props) => {
  let loader = null;
  let { modalIsOpen, closeModal, confirmTime, isFetching } = props;

  if (isFetching) {
    loader = <Loader />;
  }

  return (
    <Modal
      ariaHideApp={false}
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={style}
      contentLabel=""
    >
      <Row>
        <Span>
          <h4 className="float-left ot-modal__title">
            <FormattedMessage id={`${module_id}.reserve.appointment`} />
          </h4>
        </Span>
      </Row>
      {props.children}
      <Row>{loader}</Row>
      <Row>
        <OTButtonGroup type={'big'} fullWidth collapseOnMobile>
          <OTButton
            disabled={isFetching}
            type="big"
            color={'gray'}
            onClick={closeModal}
            message={'back'}
          />
          <OTButton
            disabled={isFetching}
            type="big"
            onClick={confirmTime}
            message={'OK'}
          />
        </OTButtonGroup>
      </Row>
    </Modal>
  );
};

Modal.setAppElement('body');
export default AppointmentModal;
